import { render, staticRenderFns } from "./CatalogView.vue?vue&type=template&id=338aad8c"
import script from "./CatalogView.vue?vue&type=script&lang=ts"
export * from "./CatalogView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports